/**
 * O registro (ou algo dentro dele) veio com campos que não abriram no cofre?
 *
 * O backend nunca derruba a resposta por um campo cifrado que não abre — cofre
 * lacrado, versão da chave aposentada: o campo chega `null` e listado em
 * `unreadable_fields` (serialização do model) ou `unavailable_fields` (listas
 * montadas à mão). Ver HasVaultKey::readSafely no backend.
 *
 * Quem EDITA precisa checar isto antes de salvar: o formulário teria o campo
 * vazio e gravaria o vazio por cima do dado verdadeiro.
 *
 * Olha o próprio objeto e um nível abaixo (endereço, telefones, paciente).
 */
export function hasUnreadableFields(data) {
  if (!data || typeof data !== "object") return false;

  const own = (obj) =>
    !!obj &&
    typeof obj === "object" &&
    ((obj.unreadable_fields?.length ?? 0) > 0 ||
      (obj.unavailable_fields?.length ?? 0) > 0);

  if (own(data)) return true;

  return Object.values(data).some((value) =>
    Array.isArray(value) ? value.some(own) : own(value)
  );
}
